module.exports = __webpack_public_path__ + "static/media/icon-yelp.1e3637e9.svg";